import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosInstance';

const ContactAdmin = () => {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await axiosInstance.get('/contact');
      setContacts(response.data);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4 text-gray-900 dark:text-[rgb(211,219,236)]">Contact</h1>
      <ul>
        {contacts.map(contact => (
          <li key={contact._id} className='text-gray-900 dark:text-[rgb(211,219,236)]'>{contact.name}: {contact.email} - {contact.message}</li>
        ))}
      </ul>
    </div>
  );
};

export default ContactAdmin;
